__turbopack_context__.v({
  "heroSection": "HeroSection-module__2k8MBW__heroSection",
  "largeHeroSection": "HeroSection-module__2k8MBW__largeHeroSection",
  "largeHeroSectionContent": "HeroSection-module__2k8MBW__largeHeroSectionContent",
  "mediumHeroSection": "HeroSection-module__2k8MBW__mediumHeroSection",
  "mediumHeroSectionContent": "HeroSection-module__2k8MBW__mediumHeroSectionContent",
  "smallHeroSection": "HeroSection-module__2k8MBW__smallHeroSection",
  "smallHeroSectionContent": "HeroSection-module__2k8MBW__smallHeroSectionContent",
});
